// extracted by mini-css-extract-plugin
export var badge = "_h6-2";
export var detailsPanel = "_h6-0";
export var resultRow = "_h6-1";